// extracted by mini-css-extract-plugin
export default {"wrapper":"main-07_wrapper__Fy5T4","container":"main-07_container__0qFZb","boxCard":"main-07_boxCard__kRJL0"};